export default "__VITE_ASSET__B79yYj2F__"